import { details } from "./details";
export const clients = {
	title: "Customers",
	atEventNameTitle: "at {{eventName}}",
	thisEventTitle: "in this Event",
	fileTitle: "Customers at the event {{eventName}} {{eventDate}}",
	filename: "customers_at_event_{{eventName}}_{{eventDate}}",
	searchPlaceholder: "Search by name, cpf or phone",
	period: "Period",
	until: "Until",
	onlyClientsCheckbox: "Customers with unissued notes",
	issueAllInvoicesButton: "Issue all notes",
	table: {
		name: "Name",
		document: "CPF",
		phone: "Phone",
		checkInTime: "Entry time",
		checkOutTime: "Departure time",
		housePrePaidTransactionsValue: "Prepaid at home",
		housePostPaidTransactionsValue: "Postpaid at home",
		appTransactionsValue: "Paid by app",
		bonusTransactionsValue: "Paid with bonus",
		total: "Total",
		noDataText: "No data to display.",
	},
	details,
	issueLoading: "Issuing notes...",
	issuedInvoice: "note was issued successfully",
	issuedInvoices: "notes were issued successfully",
	errorCountIssuedInvoice: "type of error was encountered when issuing notes",
	errorCountIssuedInvoices: "error types were encountered when issuing notes",
};
